"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenBuilder = void 0;

var sha256_1 = __importDefault(require("sha256"));

var models_1 = require("../models");

var ipfsService_1 = require("../ipfsService");

var xdrBuilder_1 = require("../xdrBuilder");

var stellar_sdk_1 = require("stellar-sdk");

var api_1 = require("../api");

var web3_1 = __importDefault(require("web3"));
/**
 * TokenBuilder Class
 * @param {string} secretKey string.
 * @param {NiftronCredential} credential NiftronCredential.
 */


var TokenBuilder;

(function (TokenBuilder) {
  var _this = this;

  var merchantKeypair;

  TokenBuilder.initialize = function (secretKey) {
    merchantKeypair = stellar_sdk_1.Keypair.fromSecret(secretKey);
  };
  /**
   * Creates a new Certificate Token
   * @param {CreateCertificateModel} createCertificateModel CreateCertificateModel
   * @param {CreateCertificateOptionsModel} options CreateCertificateOptionsModel
   * @returns {string} niftronId string
   */


  TokenBuilder.createCertificate = function (createCertificateModel, options) {
    return __awaiter(_this, void 0, void 0, function () {
      var tradable_1, transferable, authorizable, encryptData, tokenCost, user, IssuerPublicKey_1, previewUrl, _a, ipfsHash, data, _b, xdrs_1, niftronId, xdr, certificate, serverRes, err_1;

      var _this = this;

      var _c;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            _d.trys.push([0, 7,, 8]);

            tradable_1 = false;
            transferable = false;
            authorizable = false;
            encryptData = false;
            tokenCost = createCertificateModel.tokenCost ? createCertificateModel.tokenCost : 0;

            if (options) {
              tradable_1 = options.tradable ? options.tradable : tradable_1;
              transferable = options.transferable ? options.transferable : transferable;
              authorizable = options.authorizable ? options.authorizable : authorizable;
              encryptData = options.encryptData ? options.encryptData : encryptData;
            }

            return [4
            /*yield*/
            , api_1.getAccountById(createCertificateModel.creatorKeypair.publicKey())];

          case 1:
            user = _d.sent();

            if (user == null) {
              throw new Error("Creator account not found in niftron");
            }

            IssuerPublicKey_1 = user.publicKey;
            user.accounts.forEach(function (account) {
              if (!tradable_1 && account.accountType == "1") {
                IssuerPublicKey_1 = account.publicKey;
              }

              if (tradable_1 && account.accountType == "0") {
                IssuerPublicKey_1 = account.publicKey;
              }
            });
            previewUrl = createCertificateModel.previewImageUrl;
            return [4
            /*yield*/
            , ipfsService_1.IpfsService.AddToIPFS(createCertificateModel.tokenData, encryptData ? createCertificateModel.creatorKeypair.secret() : undefined)];

          case 2:
            _a = _d.sent(), ipfsHash = _a.ipfsHash, data = _a.data;
            return [4
            /*yield*/
            , xdrBuilder_1.XDRBuilder.mintCertificate(createCertificateModel.tokenName, createCertificateModel.tokenType, tradable_1, transferable, authorizable, createCertificateModel.creatorKeypair.publicKey(), createCertificateModel.tokenCount, sha256_1.default(data))];

          case 3:
            _b = _d.sent(), xdrs_1 = _b.xdrs, niftronId = _b.niftronId;
            xdr = void 0;
            if (!(xdrs_1 != null && xdrs_1.length > 0)) return [3
            /*break*/
            , 5];
            return [4
            /*yield*/
            , Promise.all(xdrs_1.map(function (item, index, array) {
              return __awaiter(_this, void 0, void 0, function () {
                var _a;

                return __generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      _a = xdrs_1[index];
                      return [4
                      /*yield*/
                      , xdrBuilder_1.XDRBuilder.signXDR(item.xdr, createCertificateModel.creatorKeypair.secret())];

                    case 1:
                      _a.xdr = _b.sent();
                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            }))];

          case 4:
            _d.sent();

            xdr = (_c = xdrs_1[0]) === null || _c === void 0 ? void 0 : _c.xdr;
            _d.label = 5;

          case 5:
            certificate = {
              tokenName: createCertificateModel.tokenName,
              tokenType: createCertificateModel.tokenType,
              assetRealm: models_1.TokenRealm.DIGITAL,
              tradable: tradable_1,
              transferable: transferable,
              category: models_1.TokenCategory.CERTIFICATE,
              assetCode: niftronId,
              assetIssuer: IssuerPublicKey_1,
              assetCount: createCertificateModel.tokenCount,
              previewUrl: previewUrl,
              ipfsHash: ipfsHash,
              price: tokenCost,
              xdr: xdr
            };
            return [4
            /*yield*/
            , api_1.addCertificate(certificate)];

          case 6:
            serverRes = _d.sent();

            if (serverRes == null) {
              throw new Error("Failed to submit certificate to NIFTRON");
            }

            switch (serverRes) {
              case 200:
                return [2
                /*return*/
                , certificate];

              case 201:
                throw new Error("Token Name is already taken");

              case 202:
                throw new Error("Insufficient fund in account");

              case 203:
                throw new Error("Only creators can create Tradable Tokens");

              case 400:
                throw new Error("Failed to submit certificate to NIFTRON");

              default:
                throw new Error("Failed to submit certificate to NIFTRON");
            }

            return [3
            /*break*/
            , 8];

          case 7:
            err_1 = _d.sent();
            console.log("Certificate minting error" + err_1);
            throw err_1;

          case 8:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
  * Creates a new Badge Token
  * @param {CreateBadgeModel} createBadgeModel CreateBadgeModel
  * @param {CreateBadgeOptionsModel} options CreateBadgeOptionsModel
  * @returns {string} niftronId string
  */


  TokenBuilder.createBadge = function (createCertificateModel, options) {
    return __awaiter(_this, void 0, void 0, function () {
      var tradable_2, transferable, authorizable, encryptData, tokenCost, user, IssuerPublicKey_2, previewUrl, _a, ipfsHash, data, _b, xdrs_2, niftronId, xdr, badge, serverRes, err_2;

      var _this = this;

      var _c;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            _d.trys.push([0, 7,, 8]);

            tradable_2 = false;
            transferable = false;
            authorizable = false;
            encryptData = false;
            tokenCost = createCertificateModel.tokenCost ? createCertificateModel.tokenCost : 0;

            if (options) {
              tradable_2 = options.tradable ? options.tradable : tradable_2;
              transferable = options.transferable ? options.transferable : transferable;
              authorizable = options.authorizable ? options.authorizable : authorizable;
              encryptData = options.encryptData ? options.encryptData : encryptData;
            }

            return [4
            /*yield*/
            , api_1.getAccountById(createCertificateModel.creatorKeypair.publicKey())];

          case 1:
            user = _d.sent();

            if (user == null) {
              throw new Error("Creator account not found in niftron");
            }

            IssuerPublicKey_2 = user.publicKey;
            user.accounts.forEach(function (account) {
              if (!tradable_2 && account.accountType == "1") {
                IssuerPublicKey_2 = account.publicKey;
              }

              if (tradable_2 && account.accountType == "0") {
                IssuerPublicKey_2 = account.publicKey;
              }
            });
            previewUrl = createCertificateModel.previewImageUrl;
            return [4
            /*yield*/
            , ipfsService_1.IpfsService.AddToIPFS(createCertificateModel.tokenData, encryptData ? createCertificateModel.creatorKeypair.secret() : undefined)];

          case 2:
            _a = _d.sent(), ipfsHash = _a.ipfsHash, data = _a.data;
            return [4
            /*yield*/
            , xdrBuilder_1.XDRBuilder.mintBadge(createCertificateModel.tokenName, createCertificateModel.tokenType, tradable_2, transferable, authorizable, createCertificateModel.creatorKeypair.publicKey(), createCertificateModel.tokenCount, sha256_1.default(data))];

          case 3:
            _b = _d.sent(), xdrs_2 = _b.xdrs, niftronId = _b.niftronId;
            xdr = void 0;
            if (!(xdrs_2 != null && xdrs_2.length > 0)) return [3
            /*break*/
            , 5];
            return [4
            /*yield*/
            , Promise.all(xdrs_2.map(function (item, index, array) {
              return __awaiter(_this, void 0, void 0, function () {
                var _a;

                return __generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      _a = xdrs_2[index];
                      return [4
                      /*yield*/
                      , xdrBuilder_1.XDRBuilder.signXDR(item.xdr, createCertificateModel.creatorKeypair.secret())];

                    case 1:
                      _a.xdr = _b.sent();
                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            }))];

          case 4:
            _d.sent();

            xdr = (_c = xdrs_2[0]) === null || _c === void 0 ? void 0 : _c.xdr;
            _d.label = 5;

          case 5:
            badge = {
              tokenName: createCertificateModel.tokenName,
              tokenType: createCertificateModel.tokenType,
              assetRealm: models_1.TokenRealm.DIGITAL,
              tradable: tradable_2,
              transferable: transferable,
              category: models_1.TokenCategory.BADGE,
              assetCode: niftronId,
              assetIssuer: IssuerPublicKey_2,
              assetCount: createCertificateModel.tokenCount,
              previewUrl: previewUrl,
              ipfsHash: ipfsHash,
              price: tokenCost,
              xdr: xdr
            };
            return [4
            /*yield*/
            , api_1.addBadge(badge)];

          case 6:
            serverRes = _d.sent();

            if (serverRes == null) {
              throw new Error("Failed to submit certificate to NIFTRON");
            }

            switch (serverRes) {
              case 200:
                return [2
                /*return*/
                , badge];

              case 201:
                throw new Error("Token Name is already taken");

              case 202:
                throw new Error("Insufficient fund in account");

              case 203:
                throw new Error("Only creators can create Tradable Tokens");

              case 400:
                throw new Error("Failed to submit certificate to NIFTRON");

              default:
                throw new Error("Failed to submit certificate to NIFTRON");
            }

            return [3
            /*break*/
            , 8];

          case 7:
            err_2 = _d.sent();
            console.log("Certificate minting error" + err_2);
            throw err_2;

          case 8:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
  * Creates a new GiftCard Token
  * @param {CreateGiftCardModel} createGiftCardModel CreateGiftCardModel
  * @param {CreateGiftCardOptionsModel} options CreateGiftCardOptionsModel
  * @returns { Promise<GiftCard>}  giftCard  Promise<GiftCard>
  */


  TokenBuilder.createGiftCard = function (createGiftCardModel, options) {
    return __awaiter(_this, void 0, void 0, function () {
      var tradable_3, transferable, authorizable, encryptData, tokenCost, user, IssuerPublicKey_3, previewUrl, _a, ipfsHash, data, _b, xdrs_3, niftronId, xdr, giftCard, serverRes, err_3;

      var _this = this;

      var _c;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            _d.trys.push([0, 7,, 8]);

            tradable_3 = false;
            transferable = false;
            authorizable = false;
            encryptData = false;
            tokenCost = createGiftCardModel.tokenCost ? createGiftCardModel.tokenCost : 0;

            if (options) {
              tradable_3 = options.tradable ? options.tradable : tradable_3;
              transferable = options.transferable ? options.transferable : transferable;
              authorizable = options.authorizable ? options.authorizable : authorizable;
              encryptData = options.encryptData ? options.encryptData : encryptData;
            }

            return [4
            /*yield*/
            , api_1.getAccountById(createGiftCardModel.creatorKeypair.publicKey())];

          case 1:
            user = _d.sent();

            if (user == null) {
              throw new Error("Creator account not found in niftron");
            }

            IssuerPublicKey_3 = user.publicKey;
            user.accounts.forEach(function (account) {
              if (!tradable_3 && account.accountType == "1") {
                IssuerPublicKey_3 = account.publicKey;
              }

              if (tradable_3 && account.accountType == "0") {
                IssuerPublicKey_3 = account.publicKey;
              }
            });
            previewUrl = createGiftCardModel.previewImageUrl;
            return [4
            /*yield*/
            , ipfsService_1.IpfsService.AddToIPFS(createGiftCardModel.tokenData, encryptData ? createGiftCardModel.creatorKeypair.secret() : undefined)];

          case 2:
            _a = _d.sent(), ipfsHash = _a.ipfsHash, data = _a.data;
            return [4
            /*yield*/
            , xdrBuilder_1.XDRBuilder.mintGiftCard(createGiftCardModel.tokenName, createGiftCardModel.tokenType, tradable_3, transferable, authorizable, createGiftCardModel.creatorKeypair.publicKey(), createGiftCardModel.tokenCount, sha256_1.default(data))];

          case 3:
            _b = _d.sent(), xdrs_3 = _b.xdrs, niftronId = _b.niftronId;
            xdr = void 0;
            if (!(xdrs_3 != null && xdrs_3.length > 0)) return [3
            /*break*/
            , 5];
            return [4
            /*yield*/
            , Promise.all(xdrs_3.map(function (item, index, array) {
              return __awaiter(_this, void 0, void 0, function () {
                var _a;

                return __generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      _a = xdrs_3[index];
                      return [4
                      /*yield*/
                      , xdrBuilder_1.XDRBuilder.signXDR(item.xdr, createGiftCardModel.creatorKeypair.secret())];

                    case 1:
                      _a.xdr = _b.sent();
                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            }))];

          case 4:
            _d.sent();

            xdr = (_c = xdrs_3[0]) === null || _c === void 0 ? void 0 : _c.xdr;
            _d.label = 5;

          case 5:
            giftCard = {
              tokenName: createGiftCardModel.tokenName,
              tokenType: createGiftCardModel.tokenType,
              assetRealm: models_1.TokenRealm.DIGITAL,
              tradable: tradable_3,
              transferable: transferable,
              category: models_1.TokenCategory.GIFTCARD,
              assetCode: niftronId,
              assetIssuer: IssuerPublicKey_3,
              assetCount: createGiftCardModel.tokenCount,
              previewUrl: previewUrl,
              ipfsHash: ipfsHash,
              price: tokenCost,
              xdr: xdr
            };
            return [4
            /*yield*/
            , api_1.addGiftCard(giftCard)];

          case 6:
            serverRes = _d.sent();

            if (serverRes == null) {
              throw new Error("Failed to submit giftcard to NIFTRON");
            }

            switch (serverRes) {
              case 200:
                return [2
                /*return*/
                , giftCard];

              case 201:
                throw new Error("Token Name is already taken");

              case 202:
                throw new Error("Insufficient fund in account");

              case 203:
                throw new Error("Only creators can create Tradable Tokens");

              case 400:
                throw new Error("Failed to submit giftcard to NIFTRON");

              default:
                throw new Error("Failed to submit giftcard to NIFTRON");
            }

            return [3
            /*break*/
            , 8];

          case 7:
            err_3 = _d.sent();
            console.log("Giftcard minting error" + err_3);
            throw err_3;

          case 8:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Express Transfer Token
   * @param {string} senderPublickey string.
   * @param {string} senderSecretKey string.
   * @param {string} receiverPublicKey string.
   * @param {string} NiftronId string.
   * @param {string} assetIssuer string.
   * @param {number} assetCount number.
   * @returns {string} niftronId string
   */


  TokenBuilder.expressTransferToken = function (senderPublickey, senderSecretKey, receiverPublicKey, NiftronId, assetIssuer, assetCount) {
    return __awaiter(_this, void 0, void 0, function () {
      var xdr, xdrs_4, e_1, parsedTx, txnHash, expressT, serverRes, err_4;

      var _this = this;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 8,, 9]);

            xdr = void 0;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 5,, 6]);

            return [4
            /*yield*/
            , xdrBuilder_1.XDRBuilder.expressTransfer(senderPublickey, receiverPublicKey, assetIssuer, NiftronId, assetCount)];

          case 2:
            xdrs_4 = _b.sent().xdrs;
            if (!(xdrs_4 != null && xdrs_4.length > 0)) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , Promise.all(xdrs_4.map(function (item, index) {
              return __awaiter(_this, void 0, void 0, function () {
                var _a, _b;

                return __generator(this, function (_c) {
                  switch (_c.label) {
                    case 0:
                      _a = xdrs_4[index];
                      return [4
                      /*yield*/
                      , xdrBuilder_1.XDRBuilder.signXDR(item.xdr, senderSecretKey)];

                    case 1:
                      _a.xdr = _c.sent();
                      if (!(senderSecretKey !== merchantKeypair.secret())) return [3
                      /*break*/
                      , 3];
                      _b = xdrs_4[index];
                      return [4
                      /*yield*/
                      , xdrBuilder_1.XDRBuilder.signXDR(xdrs_4[index].xdr, merchantKeypair.secret())];

                    case 2:
                      _b.xdr = _c.sent();
                      _c.label = 3;

                    case 3:
                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            }))];

          case 3:
            _b.sent();

            xdr = (_a = xdrs_4[0]) === null || _a === void 0 ? void 0 : _a.xdr;
            _b.label = 4;

          case 4:
            return [3
            /*break*/
            , 6];

          case 5:
            e_1 = _b.sent();
            throw e_1;

          case 6:
            parsedTx = new stellar_sdk_1.Transaction(xdr, stellar_sdk_1.Networks.TESTNET);
            txnHash = parsedTx.hash().toString("hex");
            expressT = {
              transferType: "0",
              sender: senderPublickey,
              receiver: receiverPublicKey,
              assetCode: NiftronId,
              assetIssuer: assetIssuer,
              assetCount: assetCount,
              xdr: xdr,
              txnHash: txnHash
            };
            return [4
            /*yield*/
            , api_1.expressTransfer(expressT)];

          case 7:
            serverRes = _b.sent();

            if (serverRes == null) {
              throw new Error("Failed to submit expressTransfer to NIFTRON");
            }

            switch (serverRes) {
              case 200:
                return [2
                /*return*/
                , expressT];

              case 201:
                throw new Error("Merchant not found");

              case 202:
                throw new Error("User not found");

              case 400:
                throw new Error("Failed to submit expressTransfer to NIFTRON");

              default:
                throw new Error("Failed to submit expressTransfer to NIFTRON");
            }

            return [3
            /*break*/
            , 9];

          case 8:
            err_4 = _b.sent();
            throw err_4;

          case 9:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Trust Token
   * @param {Keypair} senderKeypair Keypair.
   * @param {string} receiverPublicKey string.
   * @param {string} NiftronId string.
   * @param {string} assetIssuer string.
   * @param {number} assetCount number.
   * @returns {string} niftronId string
   */


  TokenBuilder.trustToken = function (trusterKeypair, NiftronId, assetIssuer) {
    return __awaiter(_this, void 0, void 0, function () {
      var xdr, xdrs_5, e_2, expressT, serverRes, err_5;

      var _this = this;

      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 8,, 9]);

            xdr = void 0;
            _b.label = 1;

          case 1:
            _b.trys.push([1, 5,, 6]);

            return [4
            /*yield*/
            , xdrBuilder_1.XDRBuilder.trust(trusterKeypair.publicKey(), assetIssuer, NiftronId)];

          case 2:
            xdrs_5 = _b.sent().xdrs;
            if (!(xdrs_5 != null && xdrs_5.length > 0)) return [3
            /*break*/
            , 4];
            return [4
            /*yield*/
            , Promise.all(xdrs_5.map(function (item, index) {
              return __awaiter(_this, void 0, void 0, function () {
                var _a;

                return __generator(this, function (_b) {
                  switch (_b.label) {
                    case 0:
                      _a = xdrs_5[index];
                      return [4
                      /*yield*/
                      , xdrBuilder_1.XDRBuilder.signXDR(item.xdr, trusterKeypair.secret())];

                    case 1:
                      _a.xdr = _b.sent();
                      return [2
                      /*return*/
                      ];
                  }
                });
              });
            }))];

          case 3:
            _b.sent();

            xdr = (_a = xdrs_5[0]) === null || _a === void 0 ? void 0 : _a.xdr;
            _b.label = 4;

          case 4:
            return [3
            /*break*/
            , 6];

          case 5:
            e_2 = _b.sent();
            throw e_2;

          case 6:
            expressT = {
              assetCode: NiftronId,
              assetIssuer: assetIssuer,
              xdr: xdr
            };
            return [4
            /*yield*/
            , api_1.trust(expressT)];

          case 7:
            serverRes = _b.sent();

            if (serverRes == null) {
              throw new Error("Failed to submit trust to NIFTRON");
            }

            switch (serverRes) {
              case 200:
                return [2
                /*return*/
                , expressT];

              case 201:
                throw new Error("Account not found");

              case 202:
                throw new Error("Token not found");

              case 203:
                throw new Error("Insufficient fund in account");

              case 400:
                throw new Error("Failed to submit trust to NIFTRON");

              default:
                throw new Error("Failed to submit trust to NIFTRON");
            }

            return [3
            /*break*/
            , 9];

          case 8:
            err_5 = _b.sent();
            throw err_5;

          case 9:
            return [2
            /*return*/
            ];
        }
      });
    });
  };
  /**
   * Transfer Token
   * @param {string} senderPublicKey string.
  * @param {string} receiverPublicKey string.
  * @param {string} NiftronId string.
   * @param {number} assetCount number.
   * @returns {string} niftronId string
   */


  TokenBuilder.testEthTransferToken = function (senderPublicKey, receiverPublicKey, assetCount, NiftronId) {
    return __awaiter(_this, void 0, void 0, function () {
      var contractOption, web3, contract_1;
      return __generator(this, function (_a) {
        try {
          contractOption = [{
            "inputs": [],
            "stateMutability": "nonpayable",
            "type": "constructor"
          }, {
            "anonymous": false,
            "inputs": [{
              "indexed": true,
              "internalType": "address",
              "name": "tokenOwner",
              "type": "address"
            }, {
              "indexed": true,
              "internalType": "address",
              "name": "spender",
              "type": "address"
            }, {
              "indexed": false,
              "internalType": "uint256",
              "name": "tokens",
              "type": "uint256"
            }],
            "name": "Approval",
            "type": "event"
          }, {
            "anonymous": false,
            "inputs": [{
              "indexed": true,
              "internalType": "address",
              "name": "from",
              "type": "address"
            }, {
              "indexed": true,
              "internalType": "address",
              "name": "to",
              "type": "address"
            }, {
              "indexed": false,
              "internalType": "uint256",
              "name": "tokens",
              "type": "uint256"
            }],
            "name": "Transfer",
            "type": "event"
          }, {
            "inputs": [{
              "internalType": "address",
              "name": "owner",
              "type": "address"
            }, {
              "internalType": "address",
              "name": "delegate",
              "type": "address"
            }],
            "name": "allowance",
            "outputs": [{
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }],
            "stateMutability": "view",
            "type": "function"
          }, {
            "inputs": [{
              "internalType": "address",
              "name": "delegate",
              "type": "address"
            }, {
              "internalType": "uint256",
              "name": "numTokens",
              "type": "uint256"
            }],
            "name": "approve",
            "outputs": [{
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }],
            "stateMutability": "nonpayable",
            "type": "function"
          }, {
            "inputs": [{
              "internalType": "address",
              "name": "tokenOwner",
              "type": "address"
            }],
            "name": "balanceOf",
            "outputs": [{
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }],
            "stateMutability": "view",
            "type": "function"
          }, {
            "inputs": [],
            "name": "decimals",
            "outputs": [{
              "internalType": "uint8",
              "name": "",
              "type": "uint8"
            }],
            "stateMutability": "view",
            "type": "function"
          }, {
            "inputs": [],
            "name": "name",
            "outputs": [{
              "internalType": "string",
              "name": "",
              "type": "string"
            }],
            "stateMutability": "view",
            "type": "function"
          }, {
            "inputs": [],
            "name": "symbol",
            "outputs": [{
              "internalType": "string",
              "name": "",
              "type": "string"
            }],
            "stateMutability": "view",
            "type": "function"
          }, {
            "inputs": [],
            "name": "totalSupply",
            "outputs": [{
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }],
            "stateMutability": "view",
            "type": "function"
          }, {
            "inputs": [{
              "internalType": "address",
              "name": "receiver",
              "type": "address"
            }, {
              "internalType": "uint256",
              "name": "numTokens",
              "type": "uint256"
            }],
            "name": "transfer",
            "outputs": [{
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }],
            "stateMutability": "nonpayable",
            "type": "function"
          }, {
            "inputs": [{
              "internalType": "address",
              "name": "owner",
              "type": "address"
            }, {
              "internalType": "address",
              "name": "buyer",
              "type": "address"
            }, {
              "internalType": "uint256",
              "name": "numTokens",
              "type": "uint256"
            }],
            "name": "transferFrom",
            "outputs": [{
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }],
            "stateMutability": "nonpayable",
            "type": "function"
          }];
          web3 = new web3_1.default("HTTP://127.0.0.1:8545");
          contract_1 = new web3.eth.Contract(contractOption, "0xab50b581a71aD946083a4E82E3dA515377EF13E4");
          return [2
          /*return*/
          , new Promise(function (resolve) {
            contract_1.methods.transfer(receiverPublicKey, assetCount).send({
              from: senderPublicKey,
              value: 0
            }).then(function (f) {
              console.log(f);
              resolve(f);
            }).catch(function (e) {
              console.log(e);
              throw new Error("Failed to submit transfer to NIFTRON");
            });
          })];
        } catch (err) {
          throw err;
        }

        return [2
        /*return*/
        ];
      });
    });
  }; // const transferCertificate = async (
  //   tokenName: string,
  //   tokenType: TokenType,
  //   tradable: boolean,
  //   transferable: boolean,
  //   tokenData: string
  // ): Promise<Certificate> => {
  //   try {
  //     const certificate: Certificate = {
  //       // _id: niftronId.id,
  //       tokenType,
  //       tradable,
  //       transferable,
  //       tokenName,
  //       assetRealm: "",
  //       assetCount: 0,
  //       previewUrl: "",
  //     };
  //     return certificate;
  //   } catch (err) {
  //     throw err;
  //   }
  // };
  // /**
  //  * Creates a new Badge Token
  //  * @param {string} tokenName string.
  //  * @param {string} tokenData string.
  //  * @param {boolean} tradable boolean.
  //  * @param {boolean} transferable boolean.
  //  * @returns {string} niftronId string
  //  */
  // const transferBadge = async (
  //   tokenName: string,
  //   tokenType: TokenType,
  //   tradable: boolean,
  //   transferable: boolean,
  //   tokenData: string
  // ): Promise<Badge> => {
  //   try {
  //     const badge: Badge = {
  //       // _id: niftronId.id,
  //       tokenType,
  //       tradable,
  //       transferable,
  //       tokenName,
  //       assetRealm: "",
  //       assetCount: 0,
  //       previewUrl: "",
  //     };
  //     return badge;
  //   } catch (err) {
  //     throw err;
  //   }
  // };
  // /**
  //  * Transfer Gift Card
  //  * @param {Keypair} senderKeypair Keypair.
  //  * @param {Keypair} receiverKeypair Keypair.
  //  * @param {NiftronId} NiftronId NiftronId.
  //  * @param {string} assetIssuer string.
  //  * @param {number} assetCount number.
  //  * @returns {string} niftronId string
  //  */
  // const transferGiftCard = async (
  //   senderKeypair: Keypair,
  //   receiverKeypair: Keypair,
  //   NiftronId: NiftronId,
  //   assetIssuer: string,
  //   assetCount: number
  // ): Promise<Certificate> => {
  //   try {
  //     let xdr;
  //     let rejectXdr;
  //     // let fundXdr;
  //     try {
  //       // //console.log(receiver)
  //       const { xdrs } = await XDRBuilder.transferGiftCard(
  //         senderKeypair.publicKey(),
  //         receiverKeypair.publicKey(),
  //         assetIssuer,
  //         props.item.assetCode,
  //         assetCount,
  //         approversList,
  //         // minTime,
  //         // maxTime
  //       )
  //       // let expireXdr;
  //       if (xdrs != null && xdrs.length > 0) {
  //         await Promise.all(
  //           xdrs.map(async (item, index, array) => {
  //             xdrs[index].xdr = await signXDR(item.xdr, keypair.secret());
  //           })
  //         );
  //         // fundXdr = xdrs[0]?.xdr
  //         xdr = xdrs[0]?.xdr
  //         rejectXdr = xdrs[1]?.xdr
  //         // cancelXdr = xdrs[2]?.xdr
  //         // expireXdr = xdrs[3]?.xdr
  //       }
  //     } catch (e) {
  //     }
  //     const certificate: Certificate = {
  //       // _id: niftronId.id,
  //       tokenType,
  //       tradable,
  //       transferable,
  //       tokenName,
  //       assetRealm: "",
  //       assetCount: 0,
  //       previewUrl: "",
  //     };
  //     return certificate;
  //   } catch (err) {
  //     throw err;
  //   }
  // };

})(TokenBuilder = exports.TokenBuilder || (exports.TokenBuilder = {}));